import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import { Combo2Service, DesignData } from "../../../services/index";
declare var google;

@Component({
  selector: "design-data-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./DesignData.html",
})
export class DesignDataComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  isLoadMask: Promise<any>;
  //  brandList = ["ARAZA","EXPOSE","SAMPLE","BRAND"];

  brandList: any = [];
  yesNoAll = ["YES", "NO", "ALL"];
  qualityList: any = [];
  typeList: any = [];
  styleList: any = [];
  fitList: any = [];
  verifyList = ["YES", "NO", "ALL"];
  data: any;
  filterExpand = false;
  filter = {
    verified: "NO",
    photo: "ALL",
  };
  gridOptions: any;
  verifyCtrl: FormControl = new FormControl();
  @ViewChild("verify") verify;
  @ViewChild("filterPanel") filterPanel;

  constructor(
    public toasterService: ToasterService,
    private combo: Combo2Service,
    private designdata: DesignData
  ) {
    this.gridOptions = {
      loading: false,
    };
  }

  ngOnInit(): void {
    this.brandCombo();
    this.styleCombo();
    this.fitCombo();
    this.qualityCombo();
    this.typeCombo();
    this.getDesignData();
    // let sql = 'SELECT design_no, brand, style, fit, type, quality, verified FROM gms_design ORDER BY verified ASC';
  }

  hotkeys(event) {}
  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind,
      brand = this.data[ind]["brand"],
      style = this.data[ind]["style"],
      type = this.data[ind]["type"],
      quality = this.data[ind]["quality"],
      fit = this.data[ind]["fit"];

    let nxtRow = $("#row-" + ind).next("tr");
    setTimeout(() => {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + fld + "-" + nxtInd).focus();
    }, 100);
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      //$('#').focus();
    }, 100);
  }

  refreshList() {}

  brandCombo() {
    let that = this;
    this.combo.brandCombo().then((res: any) => {
      that.brandList = res.data;
    });
  }
  qualityCombo() {
    let that = this;
    this.combo.qualityCombo().then((res: any) => {
      that.qualityList = res.data;
    });
  }
  typeCombo() {
    let that = this;
    this.combo.typeCombo().then((res: any) => {
      that.typeList = res.data;
    });
  }
  fitCombo() {
    let that = this;
    this.combo.fitCombo().then((res: any) => {
      that.fitList = res.data;
    });
  }
  styleCombo() {
    let that = this;
    this.combo.styleCombo().then((res: any) => {
      that.styleList = res.data;
    });
  }

  applyFilter() {
    this.filterPanel.close();
    this.getDesignData();
  }
  getDesignData() {
    this.gridOptions.loading = true;
    let params = {
      verified: this.filter.verified,
      photo: this.filter.photo,
    };
    let that = this;
    that.designdata.getDesignData(params).then((res: any) => {
      this.gridOptions.loading = false;
      that.data = res.data;
    });
  }

  save(row) {
    row.loading = true;

    let that = this;
    let params = Object.assign({}, row);
    if (
      row.fit == "" ||
      row.brand == "" ||
      row.quality == "" ||
      row.type == "" ||
      row.style == ""
    ) {
      swal("Enter values for all fields");
      setTimeout(() => {
        row.loading = false;
        row.changed = true;
        row.verified = "NO";
      }, 1500);
      return "";
    } else {
      this.designdata
        .saveDesignData(params)
        .then(function (res: any) {
          if (res.success) {
            setTimeout(() => {
              row.loading = false;
              row.changed = false;
              row.verified = "YES";
            }, 1500);
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          // let res = JSON.parse(error._body);
          swal("ERROR", "Enter values for all fields", "error");
          //console.log(error);
        });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/DesignData/DesignData.ts